import React, { useState, useEffect } from 'react';

import StringManipulator from 'Utilities/StringManipulator';

function TicketDescription({ description }) {  
  const [isDescriptionOverflown, setDescriptionOverflown] = useState(false)
  const [showMore, toggleShowMore] = useState(false)
  const descriptionStyles = showMore ? { height: 'auto' } : { maxHeight: '100px', overflow: 'hidden' }
  useEffect(() => {
    const element = document.querySelector('.ticket-description')
    if (element) { setDescriptionOverflown(element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth) }
  }, [])

  return (
    <ul className="detail-list">
      <li id="ticket-description" className="detail-list__info-box">
        <p className="detail-list__title">Description</p>

        <div className="ticket-description" style={descriptionStyles}>
          {StringManipulator.simpleFormat(description)}
        </div>

        <br />

        {isDescriptionOverflown && (
          <button className="content-section-block__title-button" type="button" onClick={toggleShowMore}>
            {showMore ? 'Less' : 'More'}
          </button>
        )}
      </li>
    </ul>
  )
}

export default TicketDescription
